import { get, useFormContext } from 'react-hook-form';
import { Checkbox } from '@repo/ui/Checkbox';

import s from './ReturnPolicyTask.module.css';
import { Text } from '../../Language/Language';
import { Flex } from '@repo/ui/Flex';

export const ReturnPolicyTask = () => {
  const { register, formState } = useFormContext();
  const { errors } = formState;

  return (
    <Flex
      className={s.attestation}
      padding={['px-24', 'md:px-0']}
      direction="column"
    >
      <label htmlFor="returnPolicy.agree" className={s.checkField}>
        <Checkbox id="returnPolicy.agree" {...register('returnPolicy.agree')} />
        <Text langKey="pdx.review.certification_text" />
      </label>
      <div>
        {errors?.returnPolicy && 'agree' in errors.returnPolicy && (
          <div style={{ color: '#800000' }}>
            {get(errors.returnPolicy, 'agree')?.message}
          </div>
        )}
      </div>
    </Flex>
  );
};
